export enum Roles {
  Owners = 'Owners',
  Authors_GPIAAUD = 'Authors_GPIAAUD',
  Authors_GPIACOR = 'Authors_GPIACOR',
  Authors_GPRMAUD = 'Authors_GPRMAUD',
  Authors_GPRMCOR = 'Authors_GPRMCOR',
  Readers_GPRM = 'Readers_GPRM',
  Readers_GPIA_BGASIA = 'Readers_GPIA_BGASIA',
  Readers_GPIA_BGEU = 'Readers_GPIA_BGEU',
  Readers_GPIA_BGNA = 'Readers_GPIA_BGNA',
  Readers_GPIA_BGSAMEA = 'Readers_GPIA_BGSAMEA',
  IT_ADMIN = 'IT_Admin'
}
